import React, { useState, useEffect } from 'react';
import { Form, Button, Modal } from 'react-bootstrap';
//API
import { BankConsilationFetchAPI } from '../../../api/BankConsilation';
//Utils
import {RenderIf} from '../../utils/RenderIf';

const MovementMatchedModal = ({ token, showModal, setShowMatchedModal, selectedTransactionStatement, selectedStatement }) => {

    console.log("selectedTransactionStatement", selectedTransactionStatement);
    console.log("selectedStatement", selectedStatement);
    const [matchedTransactions, setMatchedTransactions] = useState([]);


    const getBankStatementMovement = async () => {
        try {
            const res = await BankConsilationFetchAPI.getBankStatementMovement(token, selectedTransactionStatement._id, selectedStatement._id);
            //We check if the response is ok
            if (res.status === 200) {
                setMatchedTransactions(res.data.orders);
            } else {
                setMatchedTransactions([]);
            }
        } catch (err) {
            console.log("Error al obtener los movimientos conciliados", err);
            setMatchedTransactions([]);
        }
    }

    useEffect(() => {
        if (showModal) {
            getBankStatementMovement();
        }
    }, [showModal]);


    return (
        <Modal backdrop="static" show={showModal} onHide={() => setShowMatchedModal(false)} size="xl" centered>

            <Modal.Body>
                <div className="position-relative">
                    <div className='position-absolute top-0 start-100 translate-middle mt-2 '>
                        <div className='me-3'>
                            <button class="btn btn-outline-secondary border-0 bg-light text-secondary rounded-circle p-2 lh-1"
                                type="button" title='Cerrar'
                                onClick={() => setShowMatchedModal(false)}

                            >
                                <i class="uil uil-multiply"></i>
                            </button>
                        </div>
                    </div>
                    <h2 className="title-main-login  text-center ">
                        Detalles del movimiento conciliado
                    </h2>
                    <div className=' w-100  m-1 p-2 '>
                        <div className='d-flex justify-content-between align-items-center mb-2'>
                            <h6 className="fw-semibold"> Transacción</h6>
                        </div>

                        <div class="card border border-success-subtle border-2 " role='button' >
                            <div class="card-body">
                                <div class="d-flex justify-content-between">
                                    <div class="flex-column align-items-center">
                                        <h5 class="card-text">{selectedTransactionStatement.description}</h5>
                                        <h6 class="card-subtitle mb-2 text-body-secondary">Referencia: {selectedTransactionStatement.reference}</h6>
                                    </div>
                                    <div>
                                        <span className='text-on fw-semibold' ><span > ${selectedTransactionStatement.amount} </span> </span>
                                    </div>
                                </div>
                                <p class="card-text">Fecha: {selectedTransactionStatement.date}</p>
                                <RenderIf isTrue={selectedTransactionStatement.justification !== "" && selectedTransactionStatement.justification !== undefined}>
                                    <p class="card-text">Justificacion: {selectedTransactionStatement.justification}</p>
                                </RenderIf>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex justify-content-between pb-2 align-items-center">
                        <h5>Transacciones Conciliadas</h5>
                    </div>
                    <div class="wrapper-bank">
                        <table className="table table-hover mt-5">
                            <thead>
                                <tr className='bg-primary text-white'>
                                    <th>Fecha</th>
                                    <th>Numero de transaccion</th>
                                    <th>Monto con propina</th>
                                    <th>Monto de la transaccion</th>
                                    <th>Propina</th>
                                </tr>
                            </thead>
                            <tbody>
                                {matchedTransactions.map((t, i) => (
                                    <tr key={i}>
                                        <td>{t.createdAt}</td>
                                        <td>{t.transaction_code}</td>
                                        <td>{t.total + t.tips}</td>
                                        <td>{t.total}</td>
                                        <td>{t.tips}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => setShowMatchedModal(false)}>
                    Cerrar
                </Button>
            </Modal.Footer>

        </Modal>
        /*     <div className="modal fade show d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
            <div className="modal-dialog modal-lg" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Transacciones Conciliadas</h5>
                  <button type="button" className="close" onClick={() => setShowMatchedModal(false)}>
                    <span>&times;</span>
                  </button>
                </div>
                <div className="modal-body">
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th>Fecha</th>
                        <th>Referencia</th>
                        <th>Descripción</th>
                        <th>Monto</th>
                      </tr>
                    </thead>
                    <tbody>
                      {/*matchedTransactions.map((t, i) => (
                        <tr key={i}>
                          <td>{t.date}</td>
                          <td>{t.reference}</td>
                          <td>{t.description}</td>
                          <td>{t.amount}</td>
                        </tr>
                      ))*
                    </tbody>
                  </table>
                </div>
                <div className="modal-footer">
                  <button className="btn btn-secondary" onClick={() => setShowMatchedModal(false)}>Cerrar</button>
                </div>
              </div>
            </div>
          </div> */
    );
}

export default MovementMatchedModal;